import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SelectLanguagePage() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('');

  const handleContinue = () => {
    if (language) {
      navigate('/registration');
    }
  };

  return (
    <section className="language-section">
      <div className="language-card">
        <div className="main-container">
          {/* Icon + Header */}
          <div className="header">
            <span className="material-symbols-outlined">local_fire_department</span>
            <span className="header-title">Health Spark AI</span>
          </div>

          {/* Headings */}
          <h1 className="page-title">Select Your Language</h1>
          <p className="page-subtitle">Choose the language you're most comfortable with.</p>

          {/* Select Dropdown */}
          <div className="form-area">
            <label className="form-label">Language</label>
            <select 
              className="form-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="" disabled>Select a language...</option>
              <option value="en">English</option>
              <option value="hi">Hindi</option>
              {/* <option value="es">Spanish (Español)</option>
              <option value="fr">French (Français)</option>
              <option value="de">German (Deutsch)</option>
              <option value="it">Italian (Italiano)</option>
              <option value="pt">Portuguese (Português)</option>
              <option value="zh">Chinese (中文)</option>
              <option value="ja">Japanese (日本語)</option>
              <option value="ko">Korean (한국어)</option> */}
            </select>
          </div>
        </div>

        {/* Bottom Button - Inside card for desktop */}
        <div className="button-area">
          <button 
            className={`btn-continue ${language ? 'active' : ''}`}
            onClick={handleContinue}
            disabled={!language}
          >
            Continue
          </button>
        </div>
      </div>
    </section>
  );
}

export default SelectLanguagePage;